export default __webpack_public_path__ + "maps-examples-animate-image-layer-thumbnail-960-59acf51f8a66ac08bb1674274f7dbadc.png";